import { Theme, Resources } from 'jamespot-react-components';
import { useAppSelector, useAppDispatch } from './redux/store';
import { ActionCreators } from './redux/actions/actions';
import { WindowJ } from './utils/types';
import { initCommonComponents, initCoreComponents } from './registry';
import { commonComponentsRegistry } from './registry/CommonRegistry';
import { coreComponentsRegistry } from './registry/CoreRegistry';
import { Translation } from './utils/translation';
import socket from './utils/socket';
import { ReactRouterHistory } from './utils/router';
import ReactCore from './ReactCore';
import * as jamespotReactComponents from 'jamespot-react-components';
import { store } from './redux/initStore';
import { tinymceCommonOptions } from './initTinymce';

declare global {
    const J: WindowJ;

    interface Window {
        ReactComponents: any;
    }
}
// Externals ReactComponents
window.ReactComponents = jamespotReactComponents;

// Add common components to the registry
initCommonComponents();
initCoreComponents();

const App = new ReactCore(
    store,
    ActionCreators,
    { commonComponentsRegistry, coreComponentsRegistry },
    J.locale,
    Translation,
    socket,
);

Theme.initTheme(J.jamespotReactTheme);
App.theme = Theme.get();

App.translation.showKey = !!J.config.resourceShowKey;
App.translation?.initResources(Resources);
App.translation?.addResources({ [J.locale]: J.resources });

import lang from './translation/lang.json';
App.translation?.addResources(lang);

App.tinymceCommonOptions = tinymceCommonOptions;

if (J.jUserCurrent) {
    socket.init(J.jUserCurrent.id);
}

// Declare state AngularJS for React router
import './Router';

// Init Toast
import './Toast';

// Export ReactRouterHistory
export { ReactRouterHistory };

// Export components
export * from './components';

// Export Hooks
export * from './hooks';

// Export Types
export * from './types';

// Export store
export { useAppDispatch, useAppSelector };

// Export TinyMCE mentions queries
export { getTinyMCEMentionsQueries } from './utils/tinymce';

// Export ReactCore
export default App;
